import React, { useState } from 'react';
interface FormSectionProps {
  formData: {
    type_werkblad: string;
    parkeerplaats: string;
    overige_opmerkingen: string;
    skip_photos: boolean;
    type_werkblad_overig?: string;
  };
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export function FormSection({
  formData,
  handleInputChange,
  handleCheckboxChange
}: FormSectionProps) {
  // Type werkblad options
  const werkbladOptions = ['Hout', 'RVS', 'Composiet', 'Natuursteen', 'Overig', 'Niet van toepassing'];
  // Handle radio button change
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const syntheticEvent = {
      target: {
        name: 'type_werkblad',
        value: e.target.value
      }
    } as React.ChangeEvent<HTMLInputElement>;
    handleInputChange(syntheticEvent);
  };
  // Handle the "Overig" text field change
  const handleOverigChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const syntheticEvent = {
      target: {
        name: 'type_werkblad_overig',
        value: e.target.value
      }
    } as React.ChangeEvent<HTMLInputElement>;
    handleInputChange(syntheticEvent);
  };
  return <div className="space-y-5" data-id="element-16">
      <h2 className="text-lg sm:text-xl font-semibold text-[#052858]" data-id="element-17">
        Basisinformatie
      </h2>
      <div data-id="element-18">
        <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-19">
          Type werkblad <span className="text-red-500" data-id="element-20">*</span>
        </label>
        <div className="grid grid-cols-1 gap-3" data-id="element-21">
          {werkbladOptions.map(option => <div key={option} className={`border rounded-md p-3 transition-all ${formData.type_werkblad === option ? 'border-[#19EAC4] bg-[#C8FAF1] bg-opacity-20 shadow-sm' : 'border-gray-200 hover:border-[#19EAC4] hover:bg-[#C8FAF1] hover:bg-opacity-10'}`} data-id="element-22">
              <div className="flex items-center justify-between w-full" data-id="element-23">
                <label className="flex items-center cursor-pointer" data-id="element-24">
                  <input type="radio" name="type_werkblad_radio" value={option} checked={formData.type_werkblad === option} onChange={handleRadioChange} className="h-4 w-4 text-[#19EAC4] focus:ring-[#19EAC4] border-gray-300" required data-id="element-25" />
                  <span className="ml-2 block text-sm text-gray-700" data-id="element-26">
                    {option}
                  </span>
                </label>
                {option === 'Overig' && formData.type_werkblad === 'Overig' && <div className="flex-1 ml-4" data-id="element-27">
                    <input type="text" placeholder="namelijk..." value={formData.type_werkblad_overig || ''} onChange={handleOverigChange} className="w-full px-3 py-1 border border-[#19EAC4] rounded-md focus:outline-none focus:ring-2 focus:ring-[#19EAC4] text-sm" data-id="element-28" />
                  </div>}
              </div>
            </div>)}
        </div>
        {formData.type_werkblad === 'Natuursteen' && <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-md flex items-start" data-id="element-29">
            <span className="font-bold mr-2 text-amber-700" data-id="element-30">⚠️</span>
            <p className="text-sm text-amber-700 flex-1" data-id="element-31">
              <span className="font-bold" data-id="element-32">Let op:</span> Bij natuursteen
              werkbladen dient u zelf een gat te boren voor de installatie. Onze
              monteurs kunnen dit niet voor u doen vanwege het risico op
              beschadiging.
            </p>
          </div>}
      </div>
      <div data-id="element-33">
        <label htmlFor="parkeerplaats" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-34">
          Parkeerplaats informatie <span className="text-red-500" data-id="element-35">*</span>
        </label>
        <textarea id="parkeerplaats" name="parkeerplaats" value={formData.parkeerplaats} onChange={handleInputChange} rows={2} className="w-full px-3 py-2 sm:px-4 sm:py-3 border border-[#19EAC4] bg-white rounded-md focus:outline-none focus:ring-2 focus:ring-[#19EAC4] shadow-sm text-sm sm:text-base" placeholder="Beschrijf waar geparkeerd kan worden en eventuele toegangsinformatie" required data-id="element-36" />
      </div>
      <div data-id="element-37">
        <label htmlFor="overige_opmerkingen" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-38">
          Overige opmerkingen
        </label>
        <textarea id="overige_opmerkingen" name="overige_opmerkingen" value={formData.overige_opmerkingen} onChange={handleInputChange} rows={2} className="w-full px-3 py-2 sm:px-4 sm:py-3 border border-[#19EAC4] bg-white rounded-md focus:outline-none focus:ring-2 focus:ring-[#19EAC4] shadow-sm text-sm sm:text-base" placeholder="Optionele opmerkingen of extra informatie" data-id="element-39" />
      </div>
    </div>;
}